import { useDebouncedSearch } from '../common/useDebouncedSearch.hook';
import { searchWorkItems } from './api';
import type { WorkItemSearchView } from './models';

export const useWorkItemSearch = (query: string, delayMs = 300): { results: WorkItemSearchView[]; loading: boolean; error: Error | null } =>
    useDebouncedSearch<WorkItemSearchView>(query, searchWorkItems, delayMs);
